import React from "react";
import { Check } from "lucide-react";

const BENEFITS = [
  {
    t: "Strong, lightweight, corrosion-resistant",
    d: "Aluminum frames resist rust, rot and warping for decades of service life.",
  },
  {
    t: "Slim profiles for maximum glass area",
    d: "More daylight, larger views, and a quieter visual signature.",
  },
  {
    t: "Stable in extreme weather",
    d: "Minimal expansion or contraction across temperature extremes.",
  },
  {
    t: "Low maintenance by design",
    d: "No repainting or resealing — purpose-finished for longevity.",
  },
  {
    t: "Fire-resistant and coastal-ready",
    d: "Ideal for wildfire zones, salt air, and high-humidity climates.",
  },
  {
    t: "Clean, contemporary finish",
    d: "Works with minimalist, traditional, and hybrid architectural languages.",
  },
];

export default function Benefits() {
  return (
    <section
      id="aluminum"
      data-testid="benefits-section"
      className="relative bg-cream"
    >
      <div className="container-vlx py-24 md:py-32">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">The Material of Choice</span>
          <div className="mt-4 mx-auto rule-gold" />
          <h2 className="heading-lg mt-8 text-[34px] md:text-[54px] leading-[1.08] text-[#0f2420]">
            Why aluminum is the{" "}
            <em className="italic font-light text-[#7a5b2f]">
              framework of modern design.
            </em>
          </h2>
          <p className="mt-6 text-neutral-700 text-[15px] leading-[1.95] font-nunito max-w-xl mx-auto">
            Aluminum is the ideal frame material for residential and commercial
            projects — combining strength, efficiency, and a timeless design
            language that lets glass take center stage.
          </p>
        </div>

        <div className="mt-16 md:mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#c99658]/25">
          {BENEFITS.map((b, i) => (
            <div
              key={b.t}
              data-testid={`benefit-${i}`}
              className="group bg-cream p-8 md:p-10 transition-colors duration-500 hover:bg-white"
            >
              <div className="flex items-center gap-4 mb-5">
                <span className="text-[11px] tracking-[0.4em] uppercase font-raleway text-[#7a5b2f]">
                  0{i + 1}
                </span>
                <span className="flex-1 h-px bg-[#c99658]/30" />
                <Check
                  className="w-4 h-4 text-[#c99658] opacity-60 group-hover:opacity-100 transition-opacity"
                  strokeWidth={2}
                />
              </div>
              <h3 className="heading-lg text-[22px] md:text-[24px] text-[#0f2420] leading-[1.2]">
                {b.t}
              </h3>
              <p className="mt-4 text-neutral-600 text-[14px] leading-[1.8] font-nunito">
                {b.d}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
